import { Button, ButtonProps, useConfirmationModal } from '@bridebook/aura';
import { Bin } from '@bridebook/aura/src/icons';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

interface IProps {
  onConfirm: () => void | Promise<void>;
}
export const RsvpDeleteButton = ({ onConfirm, ...props }: IProps & ButtonProps) => {
  const { t } = useTranslation();

  const { openModal } = useConfirmationModal();
  const handleOpenModal = useCallback(() => {
    openModal({
      title: t('weddingWebsite:rsvp.form.delete.title'),
      text: t('weddingWebsite:rsvp.form.delete.text'),
      primaryButtonText: t('weddingWebsite:rsvp.form.delete.confirm'),
      secondaryButtonText: t('weddingWebsite:rsvp.form.delete.abort'),
      onPrimaryButtonClick: async () => {
        await onConfirm();
      },
    });
  }, [onConfirm, openModal, t]);

  return (
    <Button
      type="button"
      variant="secondary"
      size="lg"
      icon={Bin}
      onClick={handleOpenModal}
      {...props}
    />
  );
};
